import React, { useEffect, useState } from "react";
import "./Maintainence.css";
import DynamicBanner from "../../include/DynamicBanner";
import DynamicFacilities from "./Partials/DynamicFacilities";
import api from "../../../../api";


const toArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [val];
};

const Maintainence = () => {
 const [banner, setBanner] = useState({
  title: "",
  images: [],
  mobile_images: [],
});

  const [contentSection, setContentSection] = useState({
    heading: "",
    paragraphs: [],
    readmore_content: [],
    read_more_btn: "Read More",
    read_less_btn: "Read Less",
    doc_card_heading: "Download Maintenance Documents",
    download_links: [],
  });
  const [showMore, setShowMore] = useState(false);
  const [showDocs, setShowDocs] = useState(false);
  const [facilityCards, setFacilityCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/api/sitepages/about-us/maintainence");
        const data = res.data || {};

        // Normalize banner
        const bannerData = data.banner_data || {};
       const normalizedBanner = {
  title: bannerData.title || bannerData.heading || "",
  images: toArray(bannerData.images),
  mobile_images: toArray(bannerData.mobile_images),
};

        // Find content_section in groups[]
        const contentSectionData =
          (Array.isArray(data.groups) &&
            data.groups.find((g) => g.content_section)?.content_section) ||
          data.content_section ||
          {};

        const normalizedContent = {
          heading: contentSectionData.heading || "",
          paragraphs: contentSectionData.paragraphs || [],
          readmore_content: contentSectionData.readmore_content || [],
          read_more_btn: contentSectionData.read_more_btn || "Read More",
          read_less_btn: contentSectionData.read_less_btn || "Read Less",
          doc_card_heading: contentSectionData.doc_card_heading || "Download Maintenance Documents",
          download_links: contentSectionData.download_links || [],
        };

        // Find facilities_section.cards
        const facilitiesSectionData =
          (Array.isArray(data.groups) &&
            data.groups.find((g) => g.facilities_section)?.facilities_section) ||
          data.facilities_section ||
          {};

        const cards =
          Array.isArray(facilitiesSectionData.cards)
            ? facilitiesSectionData.cards.map((c) => ({
                title: c.title || "",
                text: c.text || "",
                image: c.image_url || c.image || "",
                alt: c.title || "",
              }))
            : [];

        if (!cancelled) {
          setBanner(normalizedBanner);
          setContentSection(normalizedContent);
          setFacilityCards(cards);
        }
      } catch (err) {
        console.error("Error fetching maintenance data:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
<DynamicBanner
  title={banner.title}
  bgImage={banner.images}
  bgImageMobile={banner.mobile_images}
/>


      <section className="content-section-maintainence mt-0 mt-md-3">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            {/* Left Content */}
            <div className="col-md-8 col-12">
              <div className="sec-title text-center">
                <h2
                  // heading may contain HTML line breaks — render safely if necessary
                  dangerouslySetInnerHTML={{ __html: contentSection.heading || "" }}
                />
              </div>

              <div className="content-container">
                {contentSection.paragraphs.map((p, i) => (
                  <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
                ))}

                {/* Hidden extra content */}
                {showMore &&
                  contentSection.readmore_content.map((p, i) => (
                    <div className="extra-content" key={i}>
                      <p dangerouslySetInnerHTML={{ __html: p }} />
                    </div>
                  ))}

                {/* Read More Button */}
                {contentSection.readmore_content.length > 0 && (
                  <button
                    className="readmoreall mb-3 mb-md-0"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? contentSection.read_less_btn : contentSection.read_more_btn}
                  </button>
                )}
              </div>
            </div>

            {/* Right Card */}
          <div className="col-md-4 col-12">
  <div className="custom-card">
    <div className="custom-card-header">
      {contentSection.doc_card_heading}
    </div>

    <div className="custom-card-body">

      {/* Always show FIRST 3 links */}
      {contentSection.download_links.slice(0, 3).map((dl, i) => (
        <div className="doc-entry" key={i}>
          <a
            href={`${process.env.REACT_APP_API_URL}/public${dl.url}`}
            className="doc-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {dl.title}
          </a>
        </div>
      ))}

      {/* SHOW hidden links ONLY if showDocs=true */}
      {showDocs &&
        contentSection.download_links.slice(3).map((dl, idx) => (
          <div className="extra-docs doc-entry" key={idx}>
            <div >
              <a
                href={`${process.env.REACT_APP_API_URL}/public${dl.url}`}
                className="doc-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {dl.title}
              </a>
            </div>
          </div>
        ))}

      {/* Show Read More ONLY if more than 3 documents */}
      {contentSection.download_links.length > 3 && (
        <div className="text-center">
          <button
            className="view-more-btn-maintenence"
            onClick={() => setShowDocs(!showDocs)}
          >
            {showDocs ? contentSection.read_less_btn : "View More"}
          </button>
        </div>
      )}
    </div>
  </div>
</div>

          </div>

          <DynamicFacilities heading={/* fallback handled inside Facilities */ undefined} cards={facilityCards} />
        </div>
      </section>
    </>
  );
};

export default Maintainence;
